import React from "react";
import useAxios from "axios-hooks";
import OptionsTable from "../../../../../Table/OptionsTable";

const columns = [
  {
    key: "column1",
    name: "Client ID",
    fieldName: "clientID",
    maxWidth: 20,
    isResizable: true,
  },
  {
    key: "column2",
    name: "Name",
    fieldName: "name",
    minWidth: 200,
    isResizable: true,
  },
];

const ClientsTable = ({ setOptionTable }) => {
  const [{ data, loading }] = useAxios("/cobrand/clients");

  return (
    <OptionsTable
      columns={columns}
      data={data}
      fieldName="client"
      objectKey="clientID"
      loading={loading}
      setOptionTable={setOptionTable}
      title="Clients"
      multiSelect
    />
  );
};

export default ClientsTable;
